import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function MethodSection() {
  return <section className="py-16 md:py-24 bg-cinnamon text-cream relative overflow-hidden" data-id="element-139">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-140"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-dark-brown opacity-10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-141"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="text-center mb-12" data-id="element-144">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-cream" data-id="element-145">
              EL MÉTODO DE ENGAÑO SENSORIAL LATINO
            </h2>
            <div className="w-24 h-1 bg-terracotta mx-auto rounded-full mb-8" data-id="element-146"></div>
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-cream/90" data-id="element-147">
          <FadeIn delay={0.1} data-id="element-148">
            <p data-id="element-149">
              He diseñado una estrategia específica para la mujer latina que
              vive en Estados Unidos. No vamos a usar pastillas ni batidos
              caros.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-150">
            <div className="bg-dark-brown/20 p-6 md:p-8 rounded-2xl border border-cream/10 backdrop-blur-sm my-8" data-id="element-151">
              <div className="flex items-center justify-center mb-4" data-id="element-152">
                <Sparkles className="w-8 h-8 text-terracotta mr-3" data-id="element-153" />
                <h3 className="text-2xl font-serif font-bold text-cream" data-id="element-154">
                  El "Botiquín de la Abuela"
                </h3>
              </div>
              <p className="text-center" data-id="element-155">
                Vamos a usar especias como la canela de Ceilán, la vainilla real
                y el clavo para desactivar los receptores de azúcar en tu
                cerebro.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-156">
            <p data-id="element-157">
              Al usar estas especias con mi técnica de "Engaño Sensorial", tu
              cuerpo deja de pedir dulce, tu insulina baja y, por fin, tu
              organismo suelta el agua retenida.
            </p>
            <p className="font-bold text-2xl text-center mt-8 text-cream" data-id="element-158">
              El resultado: el abdomen se deshincha y ese botón vuelve a cerrar.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}